export const skipInactivityUrls = ['/','/kiosk-code', '/beeper', '/thanks'];
export const skipOrderTypeModelUrls = ['/','/kiosk-code'];